import { motion } from "framer-motion";
import { whyChooseUs } from "@/data/company";

export const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12"
    >
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-1">
          <p className="text-xs uppercase tracking-[0.2em] text-[#22d3ee] font-bold mb-4">
            Why NetForge
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white leading-tight">
            The difference is in how we work.
          </h2>
          <p className="mt-5 text-slate-400 leading-relaxed">
            We&apos;re obsessed with outcomes. Here&apos;s what makes partnering with us
            feel effortless.
          </p>
        </div>

        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {whyChooseUs.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`why-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#0a0f1e] p-8 hover:bg-[#10182b] transition-colors"
            >
              <div className="font-heading text-5xl font-black text-white/10 mb-4">
                0{i + 1}
              </div>
              <h3 className="font-heading text-lg font-bold text-white mb-2">
                {w.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
